import App from './pages/App';
import Login from './pages/Login';
import Playlist from './pages/Playlist';
import { useAppSelector } from './store/hooks';
import { selectSelectedPlaylist } from './store/slices/playlistSlice';

export default function Root() {
  const isLoggedIn = useAppSelector((s) => s.auth.isLoggedIn);
  const selectedPlaylist = useAppSelector(selectSelectedPlaylist);

  // 로그인되지 않으면 Login 표시
  if (!isLoggedIn) {
    return <Login />;
  }

  // 플레이리스트가 선택되지 않았으면 Playlist 표시
  if (!selectedPlaylist) {
    return <Playlist />;
  }

  // 플레이리스트가 선택되었으면 App 표시
  return <App />;
}
